import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";

import { HttpclientService } from "../../../../shared";
import { Subject } from "rxjs";

import { wsItemCollectionStudentInfoParm } from "./wsItemCollectionStudentInfo";
import { wsItemCollectionStudentUpdateInfo } from "./wsItemCollectionStudentInfo";

import { wsItemCollectionStudentAddEditInfoParm } from "./wsItemCollectionStudentAddEditInfo";
import { wsItemCollectionStudentAddEditUpdateInfoParm } from "./wsItemCollectionStudentAddEditInfo";

@Injectable()
export class DataService_itemcollection {
	constructor(private http: HttpClient, private httpclientService: HttpclientService) {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	ItemCollectionStudentSelectList
	//
	//-----------------------------------------------------------------------------------------------------
	ItemCollectionStudentSelectList(parm: wsItemCollectionStudentInfoParm) 
	{
		var postResult$ = new Subject();
		var url = "StudentDemographic/ItemCollectionStudentSelectList";

		var promise$ = this.httpclientService.post(url, parm);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	ItemCollectionStudentUpdate
	//
	//-----------------------------------------------------------------------------------------------------
	ItemCollectionStudentUpdate(parm: wsItemCollectionStudentUpdateInfo) 
	{
		var postResult$ = new Subject();
		var url = "StudentDemographic/ItemCollectionStudentUpdate";

		var promise$ = this.httpclientService.post(url, parm);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	ItemCollectionStudentAddEditGetData
	//
	//-----------------------------------------------------------------------------------------------------
	ItemCollectionStudentAddEditGetData(parm: wsItemCollectionStudentAddEditInfoParm) 
	{
		var postResult$ = new Subject();
		var url = "StudentDemographic/ItemCollectionStudentAddEditGetData";

		var promise$ = this.httpclientService.post(url, parm);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	ItemCollectionStudentAddEditUpdate
	//
	//-----------------------------------------------------------------------------------------------------
	ItemCollectionStudentAddEditUpdate(parm: wsItemCollectionStudentAddEditUpdateInfoParm) 
	{
		var postResult$ = new Subject();
		var url = "StudentDemographic/ItemCollectionStudentAddEditUpdate";

		var promise$ = this.httpclientService.post(url, parm);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}	
}
